import css from './sass/style.scss';

require('./js/polyfills.js');
require('./js/anim.js');
require('./js/form.js');
require('./js/init.js');
require('./js/carousels.js');
require('./js/gototarget.js');
require('./js/ismobile.js');
require('./js/validate.js');



require('./img/distinctions/image-01.jpg');
require('./img/distinctions/image-01@2x.jpg');
require('./img/distinctions/image-02.jpg');
require('./img/distinctions/image-02@2x.jpg');
require('./img/distinctions/image-03.jpg');
require('./img/distinctions/image-03@2x.jpg');
require('./img/distinctions/image-04.jpg');
require('./img/distinctions/image-04@2x.jpg');
require('./img/distinctions/image-05.jpg');
require('./img/distinctions/image-05@2x.jpg');
require('./img/distinctions/image-06.jpg');
require('./img/distinctions/image-06@2x.jpg');

require('./img/intro/image.jpg');
require('./img/intro/image@2x.jpg');
require('./img/service/image-1.jpg');
require('./img/service/image-1@2x.jpg');
require('./img/service/image-2.jpg');
require('./img/service/image-2@2x.jpg');
